enum LocalAuthDialogFields {
	ENABLED = "enabled",
	SOAP_ENABLED = "soap_enabled",
	SOAP_ANONYMOUS = "soap_anonymous",
	REST_ENABLED = "rest_enabled",
	REST_ANONYMOUS = "rest_anonymous",
	TIME_SKEW = "time_skew",
	REFRESH_EXPIRATION = "refresh_expiration",
	ACCESS_EXPIRATION = "access_expiration",
	DISKSPACE_ANONYMOUS = "diskspace_anonymous",
	DISKSPACE_USER = "diskspace_user",
	MAXFILES_ANONYMOUS = "maxfiles_anonymous",
	MAXFILES_USER = "maxfiles_user",
	UPLOAD_ANONYMOUS = "upload_anonymous",
	UPLOAD_USER = "upload_user"
}

export default LocalAuthDialogFields;